module.exports = __webpack_public_path__ + "img/truck.f5b7ab56.svg";